import React from 'react'
import { appConfig } from 'config'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Row } from 'antd'
import { ActionButton } from 'Components/button'
import { formatAddress } from 'helpers/format'
import { Data } from 'Store/merchants/types'
import { MyGoogleMap } from 'Components/utilities'
import { EditOutlined } from '@ant-design/icons'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import InfoItem from './InfoItem'
const MyGoogleMaps: any = MyGoogleMap

type Props = {
  mode: any
  setEditMap?: (val: boolean) => void
  formData?: any
  detail?: Data
  readonly?: boolean
}

const MerchantAddress: React.FunctionComponent<Props> = props => {
  const { mode, detail, setEditMap = () => {}, formData, readonly = false } = props
  const breakpoint = useBreakpoint()
  const xs = breakpoint.xs || false
  const isApproveMode = mode === 'approve'

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  return (
    <BoxWrapper>
      <Row justify="start" gutter={16}>
        <Col>
          <BoxTitle>ที่ตั้งร้านค้า</BoxTitle>
        </Col>
      </Row>
      <Row>
        <Col md={24} xs={24}>
          {renderInfo(
            'ที่อยู่ร้านค้า',
            formatAddress(
              detail?.owner_address,
              detail?.owner_district,
              detail?.owner_amphor,
              detail?.owner_province,
              detail?.owner_postcode,
            ),
          )}
          {renderInfo('Latitude', formData?.lat)}
          {renderInfo('Longitude', formData?.long)}
          <Row justify="space-between" align="middle">
            <Col>
              <InfoTitle>ที่ตั้งร้านค้า</InfoTitle>
            </Col>
            {!isApproveMode && !readonly && (
              <Col>
                <ActionButton
                  text=""
                  icon={<EditOutlined />}
                  label="แก้ไข"
                  action="edit"
                  onClick={() => setEditMap(true)}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col md={24} xs={24}>
              <MapWrapper>
                <MyGoogleMaps
                  lat={formData?.lat || 0}
                  long={formData?.long || 0}
                  isMarkerShown
                  googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${appConfig.googleMapKey}`}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `${xs ? '150px' : '250px'}` }} />}
                  mapElement={<div style={{ height: `100%`, borderRadius: '10px' }} />}
                />
              </MapWrapper>
            </Col>
          </Row>
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const MapWrapper = styled.div`
  padding: 10px 0;
`

export default MerchantAddress
